import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';

const initialState = {
  error: null,
  data: [],
  addData: {},
};

const slice = createSlice({
  name: 'utilityCategories',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getUtilityCategoriesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateUtilityCategory(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },
  },
});

export default slice.reducer;

export function getUtilityCategories() {
  return async () => {
    try {
      const response = await get('utilityCategories');
      if (response.status) {
        dispatch(slice.actions.getUtilityCategoriesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addUtilityCategory(body) {
  return async () => {
    try {
      const response = await post('utilityCategories', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityCategory(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateUtilityCategory(body) {
  return async () => {
    try {
      const response = await put('utilityCategories', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityCategory(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deactivateUtilityCategory(body) {
  return async () => {
    try {
      const response = await deleteMethod('utilityCategories', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityCategory(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
